import { MenuProps, components } from "react-select";

import styles from "./select-layout.module.scss";

const Menu = ({ children, ...props }: MenuProps) => (
  <components.Menu
    {...props}
    innerProps={{ ...props.innerProps, id: styles.menu }}
  >
    {children}
  </components.Menu>
);

export default Menu;
